/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface IAccountProfileEditInputProps {
    id?: string;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    type: any;
    value?: string;
    pattern?: string;
    className: string;
    maxLength?: string;
    disabled?: boolean;
    onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
}

export interface IAccountProfileEditInput {
    key: string;
    AddressItem: INodeProps;
    label: React.ReactNode;
    alert: React.ReactNode;
    input: React.ReactNode;
}

const GetMaxLength = (maxLength?: string): number | undefined => {
    if (maxLength) {
        const parsedMaxLength = Number.parseInt(maxLength, 10);
        if (!isNaN(parsedMaxLength)) {
            return parsedMaxLength;
        }
    }

    return undefined;
};

const AccountProfileEditInput: React.FC<IAccountProfileEditInputProps> = ({
    id,
    type,
    value,
    pattern,
    className,
    maxLength,
    disabled,
    onChange
}) => (
    <input
        id={id}
        type={type}
        value={value}
        className={`${className}-input ${className}-${id}`}
        pattern={pattern !== '' ? pattern : undefined}
        aria-required='true'
        maxLength={GetMaxLength(maxLength)}
        disabled={disabled}
        onChange={onChange}
    />
);

export default AccountProfileEditInput;
